var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('list-item-hover',{attrs:{"click":_vm.logout}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.logoutText)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }